import Slippages from "./Slippages";
export default Slippages;
